<template>
  <div id="app">
    <header class="header">
      <a href="https://www.danielwellington.com" title="Go to the store" target="_blank" rel="noopener" class="dw-shop header__back">
        <span class="header__arrow">
          <span class="header__icon icon-arrow"></span>
          <span class="header__continue">{{ $t('continue') }}</span>
        </span>
      </a>
      <router-link :to="locale" class="dw-logo router-link-active" title="Daniel Wellington"></router-link>
      <div style="flex: 1"></div>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
  import Countries from './utils/countries'
  export default {
    name: 'app',
    data: () => ({
      locale: (window.location.pathname.split('/').filter(a => a)[0] || '')
    }),
    mounted () {
      const langs = {
        da: 'dk',
        ge: 'de',
        sa: 'sa_ar',
        sv: 'se',
        zh: 'cn',
        kz: 'kz_kk'
      }

      this.$i18n.locale = langs[this.locale] || (this.locale || 'en')
      if (process.env.NODE_ENV === 'production') {
        /*eslint-disable */
        window.dataLayer.push({
          ['site.strongholdName']: Countries(this.$i18n.locale).stronghold,
          ['site.websiteId']: this.$i18n.locale,
          ['site.storeViewId']: this.$i18n.locale,
          ['site.websiteName']: Countries(this.$i18n.locale).country,
          ['site.version']: '1',
          ['user.isInternal']: document.cookie.indexOf('isinternal=') > -1
                                ? 'yes'
                                : 'no',
          ['site.environment']: window.location.host.indexOf('test-') > -1
                                ? 'stage'
                                : window.location.host.indexOf('dev-') > -1
                                  ? 'test'
                                  : 'prod',
        })
        // Initiate GA after datalayer has been populated
        var gaEnv = window.location.hostname.split('-')[0];
        if (gaEnv !== 'localhost' && gaEnv !== 'test' && gaEnv !== 'dev') {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5Z46J5');
      }
        /*eslint-enable */
      }

      window.addEventListener('online', () => {
        this.$store.commit('connected', true)
      }, false)
      window.addEventListener('offline', () => {
        this.$store.commit('connected', false)
      }, false)
    }
  }
</script>

<style scoped>
  #app {
    text-align: center;
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .header {
    position: relative;
    z-index: 10;
    background: #17212F;
    padding: 0 20px;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .7);
  }
  .dw-logo {
    display: block;
    background-color: transparent;
    background-image: url(data:image/svg+xml;base64,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);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50%;
    width: 80%;
    max-width: 300px;
    height: 1.4em;
    line-height: 1.4em;
  }
  .header__back {
    text-align: left;
    flex: 1;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 2px;
  }
  .header__icon {
    transform: rotate(-180deg);
    display: inline-block;
    line-height: 19px;
    font-size: 17px;
    margin-right: 10px;
  }

  @media only screen and (max-device-width: 768px) {
    #app {
      height: auto;
    }
  }

  @media only screen and (max-device-width: 736px) {
    #app {
      display: block;
    }
    .header {
      z-index: 2;
    }
    .header__continue {
      display: none;
    }
  }
</style>

<style src="./styles/reset.scss" lang="scss"></style>
<style src="./assets/dw-icons/styles.css" lang="css"></style>



// WEBPACK FOOTER //
// App.vue?0417791f